import { CardContent } from '@mui/material'
import { EmployeeStatistic, EmployeeTable, EmployeeTableFilter } from '@components/user'
import { useRouteQuery } from '@hooks/useRouteQuery'
import { BoxPage } from '@/components/common'
import { Card } from '@/@core/components/mui/Card'
import { useQuery } from '@tanstack/react-query'
import { ActivityLogTypeEnum, IUser, User, UserTypeEnum } from '@/@data'
import AppLogs from '@/components/common/AppLogs'
import { CreateEmployeeDrawer } from '@/components/user/CreateEmployeeDrawer'
import { useTranslator } from '@/hooks/useTranslator'
import { useEffect, useState, useMemo } from 'react'

const Employee = () => {
  const { searchQuery, updateQuery } = useRouteQuery()
  const { __ } = useTranslator()
  const { serializeQuery } = useRouteQuery()
  const [isOpenCreateInternalUserDrawer, setIsOpenCreateInternalUserDrawer] = useState(false)
  const [isOpenLog, setIsOpenLog] = useState(false)
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({})
  const keywords = searchQuery.get('keywords')

  // Tạo params cho API
  const searchParams = useMemo(
    () => ({
      ...serializeQuery({
        page: searchQuery.get('page'),
        per_page: searchQuery.get('per_page'),
        keywords: searchQuery.get('keywords'),
        company_id: searchQuery.get('company_id'),
        created_from: searchQuery.get('created_from'),
        created_to: searchQuery.get('created_to'),
        status: searchQuery.get('status'),
        perPage: searchQuery.get('perPage'),
        user_type: UserTypeEnum.User
      })
    }),
    [searchQuery]
  )

  useEffect(() => {
    if (keywords) {
      updateQuery({ page: undefined })
    }
  }, [keywords])

  // Fetch data từ API
  const { refetch, data: users } = useQuery({
    ...User.objects.paginateQueryFactory(searchParams)
  })

  // Mutation để update status
  const handleSearch = (value: string) => {
    // Update URL
    updateQuery({
      search: value || undefined,
      page: 1
    })
  }

  const handleAddEmployee = () => {
    setIsOpenCreateInternalUserDrawer(true)
  }

  const handleOpenLog = () => {
    setIsOpenLog(true)
  }

  const handleEdit = (employee: IUser) => {
    console.log('Edit employee:', employee)
  }

  return (
    <BoxPage
      title={__('Employee Management')}
      breadcrumbs={[
        { label: __('Users Management'), href: '/cms/users/employee' },
        { label: __('Employee Management') }
      ]}
    >
      <Card
        sx={{
          borderRadius: 3
        }}
        className='mb-4'
      >
        <CardContent sx={{ padding: 0 }}>
          <EmployeeStatistic />
        </CardContent>
      </Card>
      <Card
        sx={{
          borderRadius: 3
        }}
      >
        <CardContent sx={{ padding: 0 }}>
          <EmployeeTableFilter 
            onSearch={handleSearch} 
            onAddEmployee={handleAddEmployee} 
            onOpenLogs={handleOpenLog}
            rowSelection={rowSelection}
          />
          <EmployeeTable 
            data={users?.data || []} 
            onEdit={handleEdit} 
            meta={users?.meta} 
            refetch={refetch}
            onRowSelectionChange={setRowSelection}
          />
        </CardContent>
      </Card>

      <CreateEmployeeDrawer
        open={isOpenCreateInternalUserDrawer}
        setOpen={setIsOpenCreateInternalUserDrawer}
        onSuccess={() => {
          refetch()
        }}
      />
      <AppLogs
        open={isOpenLog}
        setOpen={setIsOpenLog}
        title={__('History Menu Employee')}
        object_type={ActivityLogTypeEnum.User}
      />
    </BoxPage>
  )
}

export default Employee
